import Swiper from 'swiper';

export const initIngredientList = () => {
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.ingredient__container', {
      slidesPerView: 'auto',
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        375: {
          slidesPerView: 2.2437,
          spaceBetween: 16,
        },
        500: {
          slidesPerView: 2.8,
          spaceBetween: 16,
        },
        700: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 32,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      on: {
        afterInit: function () {
          let herbWrappers = document.querySelectorAll('.ingredient__wrapper');
          herbWrappers?.forEach((herbWrapper) => {
            herbWrapper?.classList.remove('gap-4', 'lg:gap-8');
          });
        },
      },
    });
  });
};
